<template>
    <div style="position: relative;">
        <el-button @click="save">Save</el-button>
        <div class="flow-design">
            <div class="zoom">
                <div class="zoom-out"></div>
                <span>100%</span>
                <div class="zoom-in"></div>
            </div>
            <div class="box-scale" id="box-scale" style="transform: scale(1); transform-origin: 50% 0 0;">
                <template v-if="startNode">
                    <start :node="startNode"></start>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
    import {Message} from "element-ui";

    import processService from "../../service/processService";
    import Start from "./Start";

    export default {
        components: {Start},
        async mounted() {
            // let resp = await processService.getNodes(this.$route.query.def || 1);
            let resp = {
                data: {"success":true,"message":"获取成功","data":[{"id":1,"name":"1","processDefinitionId":1,"state":"start","approverIds":null,"transitions":[{"id":66,"name":"zsl直接通过","source":1,"destination":8,"expression":"data => data.name === 'zsl'"},{"id":67,"name":"默认","source":1,"destination":6,"expression":null}]},{"id":2,"name":"2","processDefinitionId":1,"state":"end","approverIds":null,"transitions":[]},{"id":3,"name":"3","processDefinitionId":1,"state":"operation","approverIds":"1","transitions":[{"id":68,"name":"Pass","source":3,"destination":10,"expression":null}]},{"id":4,"name":"4","processDefinitionId":1,"state":"operation","approverIds":"1","transitions":[{"id":69,"name":"Pass","source":4,"destination":3,"expression":null}]},{"id":5,"name":"5","processDefinitionId":1,"state":"operation","approverIds":"1","transitions":[{"id":70,"name":"Pass","source":5,"destination":2,"expression":null}]},{"id":6,"name":"Node 6","processDefinitionId":1,"state":"operation","approverIds":"1","transitions":[{"id":71,"name":"Pass","source":6,"destination":9,"expression":null},{"id":72,"name":"Pass","source":6,"destination":10,"expression":null},{"id":73,"name":"Pass","source":6,"destination":4,"expression":null}]},{"id":7,"name":"7","processDefinitionId":1,"state":"operation","approverIds":"1","transitions":[]},{"id":8,"name":"8","processDefinitionId":1,"state":"operation","approverIds":"1","transitions":[{"id":74,"name":"Pass","source":8,"destination":5,"expression":null}]},{"id":9,"name":"9","processDefinitionId":1,"state":"operation","approverIds":null,"transitions":[{"id":75,"name":"Pass","source":9,"destination":10,"expression":null}]},{"id":10,"name":"10","processDefinitionId":1,"state":"operation","approverIds":null,"transitions":[{"id":76,"name":"Pass","source":10,"destination":5,"expression":null}]}]}
            };
            if (resp.data.success) {
                let nodes = resp.data.data;
                this.startNode = nodes.find(node => node.state === 'start');
                let setSrcAndDest = (transition) => {
                    for (let i = 0; i < transition.destination.transitions.length; i++) {
                        let nextTransition = transition.destination.transitions[i];
                        if (typeof nextTransition.source !== 'number') {
                            continue;
                        }

                        nextTransition.source = nodes.find(node => node.id === nextTransition.source);
                        nextTransition.destination = nodes.find(node => node.id === nextTransition.destination);
                        setSrcAndDest(nextTransition);
                    }
                };

                this.startNode.transitions.forEach(transition => {
                    transition.source = nodes.find(node => node.id === transition.source);
                    transition.destination = nodes.find(node => node.id === transition.destination);
                    if (transition.destination.transitions.length > 0) {
                        setSrcAndDest(transition);
                    }
                });
            }
        },
        data() {
            return {
                startNode: null
            };
        },
        methods: {
            async save() {
                let resp = await processService.saveNodes(this.startNode);
                if (resp.data.success) {
                    Message.success(resp.data.message);
                }
            }
        }
    }
</script>
<style scoped src="../../assets/flow-design.css"></style>